import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
    loadProfile: function() {
        const self = this,
            api = getApiClient(self.$store),
            profileId = self.$route.params.id,
            event = self.$store.state.profileFinder.event

        api.get(`/work_profiles/${profileId}`)
            .then(result => {
                self.profile = result.data

                let params = {}
                if (!event.isRemote && event.address) {
                    params.coordinates = `${event.address.latitude},${event.address.longitude}`
                }

                let address = self.profile.user.address
                api.get(address['@id'], {params})
                    .then(result => {
                        if (!event.isRemote) {
                            Vue.set(self.profile, 'distance', `${result.data.distance}km`)
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })

            })
            .catch(error => {
                console.log(error)
            })
    },

    selectProfile: function() {
        const self = this,
            profileFinderData = self.$store.state.profileFinder,
            currentIndex = profileFinderData.currentIndex,
            existingProfile = profileFinderData.profiles[currentIndex]

        if (existingProfile && existingProfile['@id']) {
            self.deleteDraftSelectionByWorkProfileIri(existingProfile['@id'], profileFinderData)
        }

        self.$store.commit('setProfileSearchProfile', {
            index: currentIndex,
            profile: self.profile,
            symplaEventsUsed: self.$store.state.profileSearchSymplaEventsUsed
        })
        self.$store.commit('increaseProfileSearchIndex')

        if (profileFinderData.currentIndex >= profileFinderData.query.quantity) {
            self.$store.commit('setProfileSearchIndex', profileFinderData.query.quantity - 1)
        }

        self.saveDraftSelection(profileFinderData, currentIndex)
        self.backToSearch()
    },

    saveDraftSelection: function(profileFinderData, slotIndex) {
        const self = this,
            api = getApiClient(self.$store),
            eventId = profileFinderData.query.eventId,
            profileSearchId = profileFinderData.profileSearchId,
            eventStatus = profileFinderData.event ? profileFinderData.event.status : null

        if (!eventId || !profileSearchId || !self.profile || !self.profile['@id']) {
            return
        }

        if (eventStatus !== 'creating') {
            return
        }

        api.post('/draft_job_selections', {
            event: `/events/${eventId}`,
            profileSearch: `/profile_searches/${profileSearchId}`,
            workProfile: self.profile['@id'],
            slotIndex
        }).catch(error => {
            console.log('Failed to save draft selection:', error)
        })
    },

    deleteDraftSelectionByWorkProfileIri: function(workProfileIri, profileFinderData) {
        const self = this,
            api = getApiClient(self.$store),
            eventId = profileFinderData.query.eventId,
            profileSearchId = profileFinderData.profileSearchId,
            eventStatus = profileFinderData.event ? profileFinderData.event.status : null

        if (!eventId || !profileSearchId || !workProfileIri || eventStatus !== 'creating') {
            return
        }

        // Note: the backend does not expose a `workProfile.id` filter for this
        // resource, so filtering has to happen client-side. Relying on the API
        // to filter by workProfile would silently return (and delete) every
        // draft selection for this profileSearch, wiping out the other already
        // selected professionals whenever quantity > 1.
        api.get('/draft_job_selections', {
            params: {
                'event.id': eventId,
                'profileSearch.id': profileSearchId,
                pagination: false
            }
        }).then(result => {
            const drafts = result.data['hydra:member'] || []
            drafts.filter(draft => {
                const draftWorkProfileIri = draft.workProfile && typeof draft.workProfile === 'object'
                    ? draft.workProfile['@id']
                    : draft.workProfile

                return draftWorkProfileIri === workProfileIri
            }).forEach(draft => {
                api.delete(draft['@id']).catch(error => {
                    console.log('Failed to delete draft selection:', error)
                })
            })
        }).catch(error => {
            console.log('Failed to find draft selection for deletion:', error)
        })
    },

    profileIsSelected: function(id) {
        const self = this,
            profiles = self.$store.state.profileFinder.profiles

        return profiles.filter(profile => {
            return profile && profile.id === id
        }).length > 0
    },

    backToSearch: function() {
        const self = this,
            replaceJob = self.$route.params.replaceJob,
            routeName = replaceJob ? 'ProfessionalReplace' : 'ProfessionalFinder'

        self.$router.push({
            name: routeName,
            params: {
                replaceJob: self.$route.params.replaceJob
            }
        })
    },

    showMedia(media, index) {
        this.showZoomMedia = true
        this.zoomMedia = media
        this.currentMedia = index
    },

    closeMedia() {
        this.zoomMedia = null
        this.showZoomMedia = false
    },

    toggleFavorite(id) {
        const self = this,
            api = getApiClient(self.$store)

        let favorites = self.$store.state.session.favoriteWorkProfiles,
            favoriteIds = favorites.map(profile => {
                return profile['@id']
            })

        if (!favoriteIds.includes(id)) {
            favoriteIds.push(id)
        } else {
            favoriteIds = favoriteIds.filter(profileId => {
                return profileId !== id
            })
        }

        api.patch(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`, {favoriteWorkProfiles: favoriteIds}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
                console.log(result.data)
            })
            .catch(error => {
                console.log(error)
            })
    },

    getPastJobTypeLabel(type) {
        let item = this.allAvailableJobTypes.filter(item => {
            return item.code === type
        })

        return item[0]?.label ?? type
    },

    getLanguageLabel(language) {
        let item = this.availableLanguages.filter(item => {
            return item.value === language
        })

        return item[0]?.label ?? language
    },

    getEducationLevelLabel(level) {
        let item = this.availableEducationLevels.filter(item => {
            return item.value === level
        })

        return item[0]?.label ?? level
    },

    exportProfile() {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`users/pdf/${self.profile.user.id}`, {responseType: 'blob'})
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data])),
                    link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${self.profile.user.name} - Perfil na Castfy.pdf`)
                document.body.appendChild(link)
                link.click()
            })
            .catch(error => {
                console.log(error)
            })
    },

    showCompletedCourseDetails(course) {
        this.completedCourseDetails = {
            ...course,
            show: true
        }
    },

    hideCompletedCourseDetails() {
        this.completedCourseDetails = {
            show: false,
            image: null,
            name: null,
            description: null
        }
    },
}
